import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, message, Checkbox, Popconfirm, Modal, Drawer } from "antd";
import { useNavigate } from "react-router-dom";
import {
  activityQuickAddCartUrl,
  orderConfirmUrl,
  liteUserNewAddressUrl,
  customerUrl,
  cartItemDeleteUrl,
  USER_TYPE,
  DUMMY_EMAIL_DOMAIN,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "../utils/constant";
import editAddressIcon from "../images/edit-address.svg";
import { formatPrice, getAuthToken, getSkuCount } from "../utils/common";
import {
  getSelectedSTObj,
  getSwithcSTAddress,
  getDefaultST,
  getContactPhone,
  getContactName,
  getSTAddress,
} from "../utils/addressUtils";
import {
  getAllCartItemIds,
  hasNonOrderableCartItems,
  addToCartErrorHandle,
  submitOrderErrorHandle,
  getBundleCartItemIds,
} from "../utils/activityHelper";
import axios from "axios";
import CartCounter from "../components/activity/CartCounter";
import CartSection from "../components/cart/CartSection";
import SwitchShipToPage from "../components/common/SwitchShipToPage";
import AddShippingAddressFormModal from "../components/common/AddShippingAddressFormModal";
import { AppContext } from "../store";
import binIcon from "Images/bin.svg";
import { getShoppingSkus, logOperation } from "Utils/operationLogUtils";
import { UpOutlined } from "@ant-design/icons";
import BundleSection from "Components/cart/BundelSection";
import PromotionRules from "Components/common/PromotionRules";
import { getTieredRule } from "Utils/apiUtils";
import { encrypt } from "Utils/crypto";
import cookie from "js-cookie";
import { addToCartDataPush, cartTrackingDataPush, dispatchEventFunc } from "Utils/analyticsUtils";
import { checkOutEvent, deleteCartItemsEvent } from "Utils/aaUtils";

type ChildComponentRef = {
  clearInput: () => void;
  setInputValue: (newValue: string) => void;
  focusInput: () => void;
};

const MyCartDrawer: React.FC<any> = (props) => {
  const { activityId, activityDetail } = props;
  const {
    checkedCartItems,
    setCheckedCartItems,
    cartData,
    refreshCartData,
    setCartCount,
    activityPermissionMeta,
  } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );
  const [sku, setSku] = useState<string>("");
  const [addToCartObj, setAddToCartObj] = useState<any>({
    shoppingQty: 1,
  });
  const [loadingCart, setLoadingCart] = useState<boolean>(false);
  const [productnotExist, setProductnotExist] = useState(false);
  const [productnotAvailable, setProductnotAvailable] = useState(false);
  const childRef = useRef<ChildComponentRef>(null);
  const navigate = useNavigate();
  const [showSwitchStPage, setShowSwitchStPage] = useState(false);
  const [showAddShipAddressModal, setShowAddShipAddressModal] = useState(false);
  const { loginState, setLoginState } = React.useContext(AppContext);
  const [allChecked, setAllChecked] = useState<boolean>(true);
  const [delConfirmOpen, setDelConfirmOpen] = useState<boolean>(false);
  const [discountedDetailDrawer, setDiscountedDetailDrawer] =
    useState<boolean>(false);
  const [rulesDrawerVisible, setRulesDrawerVisible] = useState<boolean>(false);
  const [tieredRule, setTieredRule] = useState<any>(null);
  const [closedCartTip, setClosedCartTip] = useState<boolean>(false);
  const [hasActivityNoPermission, setHasActivityNoPermission] =
    useState<boolean>(false);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const selectedShipTo = getSelectedSTObj(loginState);
  const stAddress = getSTAddress(selectedShipTo);
  const userData = loginState?.user?.user;
  const isDummyCustomer = userData?.userName?.includes(DUMMY_EMAIL_DOMAIN);

  const getNickName = () => {
    const userInfo = loginState?.user?.user;
    const lastName = userInfo?.lastName || "";
    const firstName = userInfo?.firstName || "";
    return `${lastName}${firstName}`;
  };
  const [formData, setFormData] = useState({
    nickName: getNickName(),
    phone: "",
    region: "",
    address: "",
    invoice: "",
  });

  useEffect(() => {
    setSku("");
    setAddToCartObj({
      shoppingQty: 1,
    });
  }, []);

  useEffect(() => {
    setHasActivityNoPermission(false);
  }, [selectedShipTo?.accountNumber]);

  const handleClearInput = () => {
    if (childRef.current) {
      childRef.current.clearInput();
      childRef.current.setInputValue("1");
    }
  };

  const setQuickOrderSku = (sku: string) => {
    setSku(sku);
  };

  const quickAddCartHandle = async () => {
    console.log("quick Add", sku, addToCartObj);
    if (!sku || !sku.trim()) {
      message.warning("sku不能为空");
      return;
    }
    if (!addToCartObj.shoppingQty || addToCartObj.shoppingQty <= 0) {
      message.warning("数量不能为空 或者 不能小于0");
      return;
    }
    setLoadingCart(true);
    try {
      const reqBody = {
        activityId,
        type: "activity",
        sku: sku.trim(),
        quantity: addToCartObj.shoppingQty
          ? parseInt(addToCartObj.shoppingQty)
          : 1,
        customerStNumber: selectedShipTo?.accountNumber,
      };
      const resp = await axios(activityQuickAddCartUrl, {
        method: "POST",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
        data: reqBody,
      });

      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          setHasActivityNoPermission(false);
          setSku("");
          handleClearInput();
          message.success("快速加车成功");
          const ids: number[] = respData?.data?.cartIds;
          console.log("cartId", ids);
          ids && checkedCartItems.add(ids[0]);
          setCheckedCartItems(new Set(checkedCartItems));
          refreshCartData();
          setCartCount(respData?.data.cartCount);
          logOperation({
            opUser: loginState?.user?.user?.userId,
            opTarget: "Quick_Order",
            opTargetId: sku,
            opContent: "Quick_Order_Success",
          });
          setLoadingCart(false);
          if (productnotExist || productnotAvailable) {
            setProductnotExist(false);
            setProductnotAvailable(false);
          }
          addToCartDataPush({
            cartObj: {
              cartId: activityId
            },
            placement: "cart_add_more_sku",
            method: "add_more_sku",
            products: [{
              catalogId: reqBody.sku,
              quantity: reqBody.quantity,
            }]
          })
          return;
        }
        const isActivityNoPermission =
          respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE;
        setHasActivityNoPermission(isActivityNoPermission);
        if (isActivityNoPermission) {
          message.warning(activityNoPermissionLabel);
        } else {
          addToCartErrorHandle(respData, message, "quick", "pc");
        }
        if (respData.status === "product_not_exist") {
          setProductnotExist(true);
        }
        if (respData.status === "product_not_available") {
          setProductnotAvailable(true);
        }
        logOperation({
          opUser: loginState?.user?.user?.userId,
          opTarget: "Quick_Order",
          opTargetId: sku,
          opContent: "Quick_Order_Failed",
        });
        setLoadingCart(false);
      } else {
        setLoadingCart(false);
      }
    } catch (err) {
      setLoadingCart(false);
      console.log(err);
    }
  };

  const handleCheckAll = (e: any) => {
    console.log("checkbox changed");
    const checked = e.target.checked;
    if (checked) {
      setAllChecked(true);
      const ids = getAllCartItemIds(cartData, activityDetail.activityBasicType);
      console.log("ids", ids);
      setCheckedCartItems(new Set(ids));
    } else {
      setAllChecked(false);
      setCheckedCartItems(new Set());
    }
    refreshCartData();
  };
  const handleDeleteCartItems = () => {
    console.log("delete cart items", checkedCartItems);
    if (loadingCart) return;
    setLoadingCart(true);
    axios(cartItemDeleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        activityId: activityId,
        ids: Array.from(checkedCartItems),
      },
    }).then((res) => {
      const respData = res.data;
      console.log("delete cart items", respData);
      if (respData.status === "success") {
        console.log("cart items deleted");
        setCheckedCartItems(new Set());
        refreshCartData();
        setCartCount(respData.data);
        setLoadingCart(false);
        deleteCartItemsEvent(activityId, Array.from(checkedCartItems), cartData);
      } else {
        setLoadingCart(false);
      }
    });
  };
  const handleDelOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setDelConfirmOpen(newOpen);
      return;
    }
    if (checkedCartItems.size === 0) {
      return;
    } else {
      setDelConfirmOpen(newOpen);
    }
  };
  const gotoOrderConfirm = () => {
    if (loadingCart) return;
    if (hasActivityNoPermission) {
      message.warning(activityNoPermissionLabel);
      return;
    }
    if (checkedCartItems.size === 0) {
      message.warning("请选择商品");
      setLoadingCart(false);
      return;
    }
    let shoppingItems: number[] = [],
      result = false;
    if (activityDetail.activityBasicType === "bundle_promotion") {
      shoppingItems = getBundleCartItemIds(
        Array.from(checkedCartItems),
        cartData
      );
    } else {
      shoppingItems = Array.from(checkedCartItems);
      result = hasNonOrderableCartItems(shoppingItems, cartData);
    }
    if (result) {
      message.warning("存在不可下单商品");
      return;
    }

    const selectedST = getSelectedSTObj(loginState);
    if (!selectedST) {
      setShowAddShipAddressModal(true);
      return;
    }
    // check cartData is matchRule
    if (!cartData?.matchStatus) {
      let msg =
        "您当前未满足活动规则，您可继续提交订单，此订单将会以您的协议价或飞享价进行结算，即无法参与当前活动。";
      if (cartData.allowSingleItem) {
        msg =
          "您当前未满足所有活动规则，但您可继续提交订单，此订单产品将按照您已符合的规则计算价格进行结算。";
      }
      Modal.confirm({
        className: "confirmModal",
        title: "未满足规则，继续下单？",
        content: msg,
        okText: "确认",
        cancelText: "取消",
        style: { top: "32vh" },
        onOk() {
          submitOrder(selectedST, shoppingItems, { matchStatus: false });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
      return;
    }
    if (cartData.matchStatus && cartData.exceedOrderLimit) {
      Modal.confirm({
        className: "confirmModal",
        title: "注意！您已超过此活动的购买次数上限，继续下单？",
        content: (
          <div>
            <p>
              您当前已超过此活动的购买次数上限，此订单将无法享受本次活动优惠
            </p>
            <p>
              您可以继续提交订单，系统将以产品的其他优惠价为您结算，请至订单详情页确认价格明细
            </p>
          </div>
        ),
        okText: "确认",
        cancelText: "取消",
        style: { top: "32vh", width: "440px !important" },
        onOk() {
          submitOrder(selectedST, shoppingItems, { matchStatus: false });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
      return;
    }

    submitOrder(selectedST, shoppingItems, { matchStatus: true });
  };

  const submitOrder = (
    selectedST: any,
    shoppingItems: any,
    options: { matchStatus: boolean }
  ) => {
    const reqBody = {
      shipTo: selectedST?.accountNumber,
      activityId: activityId,
      cartIds: shoppingItems,
      tieredRuleId: cartData?.currentTieredRule?.id,
    };
    setLoadingCart(true);
    axios(orderConfirmUrl, {
      method: "POST",
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
      data: reqBody,
    })
      .then((resp) => {
        if (resp.status === 200) {
          const respData = resp.data;
          if (respData?.status === "success") {
            respData.data.activityId = activityId;
            encrypt(JSON.stringify({
              reqBody,
              respData: respData.data,
            })).then((encryptedData) => {
              localStorage.setItem(
                `${activityId}OrderPreviewData`,
                JSON.stringify(encryptedData)
              );
              const location = props.location;
              const searchParams = new URLSearchParams(location.search);
              searchParams.delete("filter");
              checkOutEvent(activityId, shoppingItems, cartData);
              navigate(`/orderPreview/${activityId}?${searchParams.toString()}`);
            });
            return;
          }
          if (respData?.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
            message.warning(activityNoPermissionLabel);
            setLoadingCart(false);
            return;
          }
          submitOrderErrorHandle(respData, message);
          setLoadingCart(false);
        } else {
          message.error("操作失败，请联系在线客服");
          setLoadingCart(false);
        }
      })
      .catch((err) => {
        message.error("操作失败，请联系在线客服");
        setLoadingCart(false);
      });
    const skus = getShoppingSkus(shoppingItems, cartData);

    if (options.matchStatus) {
      logOperation({
        opUser: loginState?.user?.user?.userId,
        opTarget: "Submit_Order",
        opTargetId: JSON.stringify(skus),
        opContent: "MatchRule",
      });
    } else {
      logOperation({
        opUser: loginState?.user?.user?.userId,
        opTarget: "Submit_Order",
        opTargetId: JSON.stringify(skus),
        opContent: "NotMatchRule",
      });
    }
  };

  const getWarningMessage = () => {
    let currentMessage = "";
    if (productnotExist) {
      currentMessage = "该货号不在活动范围内";
    } else if (productnotAvailable) {
      currentMessage = "该货号不可通过网络订购";
    }
    return currentMessage;
  };

  const getCurrentShipToAddress = () => {
    const selectedAddressKey = localStorage.getItem("selectedAddressKey") || "";
    const shipTos = loginState?.user?.allShipToBillToAddresses;
    let selectedST = shipTos?.find(
      (st: any) => st.shipTo?.addressKey?.toString() === selectedAddressKey
    );

    if (!selectedST) {
      selectedST = getDefaultST(loginState);
    }

    console.log("getCurrentShipToAddress selectedST", selectedST);
    return getSwithcSTAddress(selectedST?.shipTo);
  };
  const getAddressKey = () => {
    const selectedAddressKey = localStorage.getItem("selectedAddressKey") || "";
    const shipTos = loginState?.user?.allShipToBillToAddresses;
    let selectedST = shipTos?.find(
      (st: any) => st.shipTo?.addressKey?.toString() === selectedAddressKey
    );

    if (!selectedST) {
      selectedST = getDefaultST(loginState);
    }
    console.log("getAddressKey selectedST", selectedST);

    return selectedST?.shipTo?.addressKey;
  };

  const showContactInfo = () => {
    const selectedST = getSelectedSTObj(loginState);

    return getContactName(selectedST, loginState.user);
  };

  const showPhone = () => {
    const selectedST = getSelectedSTObj(loginState);

    console.log("showPhone=======", selectedST);
    return getContactPhone(selectedST, loginState.user);
  };

  const switchShipTo = () => {
    setShowSwitchStPage(true);
  };

  const getOrderBtnStatus = () => {
    if (hasActivityNoPermission) {
      return {
        disabled: false,
        message: "去结算",
      };
    }
    if (checkedCartItems.size === 0) {
      return {
        disabled: true,
        message: "去结算",
        notDisplay: true,
      };
    }
    if (
      cartData.total === "0" ||
      cartData.total === "0.0" ||
      cartData.total === "0.00"
    ) {
      return {
        disabled: true,
        message: "去结算",
      };
    }
    const st = getSelectedSTObj(loginState);
    if (!st) {
      return {
        disabled: false,
        message: "未选择收货地址",
      };
    }
    if (!cartData.matchStatus) {
      return {
        disabled: false,
        confirm: true,
        message: "未满足规则，继续下单？",
      };
    }
    return {
      disabled: false,
      message: "去结算",
    };
  };

  const addShipAddressHandle = () => {
    resetFormData();
    setShowAddShipAddressModal(true);
  };

  const resetFormData = () => {
    let currentValues = {
      nickName: getNickName(),
      phone: "",
      region: "",
      address: "",
      invoice: "",
    };
    setFormData(currentValues);
  };

  const handleModalClose = () => {
    resetFormData();
    setShowAddShipAddressModal(false);
  };

  const refreshDetails = (authToken: string) => {
    fetch(customerUrl, {
      method: "GET",
      headers: {
        Authorization: authToken,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          console.log("customer data", res.data);
          const loginState = {
            status: "login",
            token: authToken,
            user: res.data,
          };
          setLoginState(loginState);
        } else {
          setLoginState({
            status: "failed",
            token: null,
            user: null,
          });
        }
      })
      .catch((e) => {
        console.log("e", e);
        setLoginState({
          status: "failed",
          token: null,
          user: null,
        });
      });
  };

  const handleSaveShippingAddress = (values: any) => {
    const userInfo = loginState?.user?.user;

    setShowAddShipAddressModal(false);
    let currentAttentionTo = values.nickName + "," + values.phone;
    let addressObj = {
      attentionTo: currentAttentionTo,
      building: "",
      city: values.region,
      companyOrInstitution: values.invoice,
      departmentOrLab: "",
      nickName: values.nickName,
      phoneNumber: values.phone,
      state: "",
      street: values.address,
      zipCode: "",
    };
    let submitShippingAddress = addressObj;
    let submitBillToAddress = {
      ...addressObj,
      isSameAsShippingAddress: true,
    };
    let requestBody = {
      billingAddress: submitBillToAddress,
      shippingAddress: submitShippingAddress,
    };
    console.log("handleSaveShippingAddress=requestBody", requestBody);

    setLoadingCart(true);
    axios(liteUserNewAddressUrl, {
      method: "POST",
      headers: {
        userid: userInfo.userId,
        username: userInfo.userName,
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
      data: requestBody,
    })
      .then((resp) => {
        console.log("resp", resp);
        if (resp.status === 200) {
          refreshDetails(loginState.token);
          setLoadingCart(false);
          const respData = resp.data;
          console.log("respData", respData);
          handleModalClose();
        } else {
          if (resp.data.status === "address_already_registered") {
            window.location.reload();
            return;
          }
          message.error("保存失败，请重试");
          setShowAddShipAddressModal(false);
        }
      })
      .catch((err) => {
        message.error("保存失败，请重试");
        setLoadingCart(false);
        setShowAddShipAddressModal(false);
      });
  };

  const handleSave = (values: any) => {
    console.log("Saved values:", values);
    handleSaveShippingAddress(values);
    setFormData(values);
  };

  console.log("showSwitchStPage", showSwitchStPage);
  console.log("cartData===========================", cartData);
  const originalPromoTotal = (cartData?.savingDetails as any)?.originalPromoTotal;
  return (
    <div className="my-cart-page-wrapper">
      <div className="attress-wrapper">
        {!showSwitchStPage ? (
          <div className="show-select-shipto-attress">
            <div className="select-shipped-address">{"收货地址"}</div>
            {isDummyCustomer ? <div className="contact-address-contanier">{stAddress}</div> : <>
            <div className="contact-infor">
              <label className="name-infor">{showContactInfo()}</label>
              <span className="phone-infor">{showPhone()}</span>
            </div>
            <div className="contact-address-contanier">
              {(getAddressKey() || isEmployee) ? (
                <div className="show-current-address">
                  <div className="contact-address">
                    {getCurrentShipToAddress()}
                  </div>
                  {loginState?.user?.allShipToBillToAddresses?.length > 1 && !isEmployee && (
                    <img
                      src={editAddressIcon}
                      alt="address"
                      onClick={() => switchShipTo()}
                    ></img>
                  )}
                </div>
              ) : !isEmployee ? (
                <div className="add-shipping-address-area">
                  <Button
                    className="primaryBtn add-ship-address"
                    onClick={addShipAddressHandle}
                  >
                    {"新建收货地址"}
                  </Button>
                </div>
              ) : null}
            </div>
            </>}
          </div>
        ) : (
          <div>
            <div className="select-shipped-address">{"选择收货地址"}</div>
            <SwitchShipToPage
              {...props}
              page="Shopping_Cart"
              showSwitchStPage={showSwitchStPage}
              setShowSwitchStPage={setShowSwitchStPage}
            ></SwitchShipToPage>
          </div>
        )}
      </div>

      <div className="my-cart-wrapper">
        {activityDetail.activityBasicType !== "bundle_promotion" ? (
          <>
            <CartSection
              loadingCart={loadingCart}
              allChecked={allChecked}
              setAllChecked={setAllChecked}
              {...props}
            ></CartSection>
            <div className="quick-add-order-wrapper">
              <div className="quick-add-cart-label">
                <div className="quick-add-lable">{"快速加车"}</div>
                <div
                  className={`quick-add-rule-lable ${productnotExist || productnotAvailable
                    ? "show-message"
                    : "hidden-show-message"
                    }`}
                >
                  {getWarningMessage()}
                </div>
              </div>
              <div className="quick-add-cart-container">
                <input
                  className="quick-add-cart-sku-input"
                  value={sku}
                  placeholder="请输入当前活动产品货号"
                  onChange={(e) => {
                    setProductnotExist(false);
                    setProductnotAvailable(false);
                    setQuickOrderSku(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    console.log(e);
                  }}
                ></input>
                <CartCounter
                  product={addToCartObj}
                  ref={childRef}
                // value={inputValue}
                // onChange={(value) => setInputValue(value)}
                ></CartCounter>
                <Button
                  className="primaryBtn add-to-cart-btn"
                  onClick={quickAddCartHandle}
                >
                  加购
                </Button>
              </div>
            </div>
          </>
        ) : (
          <BundleSection
            loadingCart={loadingCart}
            allChecked={allChecked}
            setAllChecked={setAllChecked}
            {...props}
          ></BundleSection>
        )}
      </div>
      {cartData.hasFurtherPromotion && !closedCartTip ? (
        <div className="my-cart-footer-fixedTip">
          <span>凑单助手I 继续选购，享受更多优惠</span>
          <span
            className="checkBtn"
            onClick={() => {
              setRulesDrawerVisible(true);
              if (tieredRule) return;
              getTieredRule(activityId, (data: any) => {
                setTieredRule(data);
              });
            }}
          >
            凑单详情
          </span>
        </div>
      ) : null}
      <div className="my-cart-footer-wrapper">
        <div className="actionWrapper">
          <Checkbox checked={allChecked} onClick={handleCheckAll}>
            <span className="btnText">全选</span>
          </Checkbox>
          <Popconfirm
            open={delConfirmOpen}
            title="删除购物车产品"
            description="确认要删除吗?"
            onConfirm={handleDeleteCartItems}
            onOpenChange={handleDelOpenChange}
            okText="确认"
            cancelText="取消"
          >
            <span className="binWrapper">
              <img alt="delete" src={binIcon}></img>
              <span className="btnText">删除</span>
            </span>
          </Popconfirm>
        </div>
        {
          <div className="innerWrapper">
            <div className="priceSumWrapper">
              <div className="left">
                <div className="priceItem">
                  <label>原价</label>
                  <span className="originTotal">
                    {checkedCartItems.size > 0
                      ? formatPrice(cartData.originalTotal)
                      : "¥ 0"}{" "}
                  </span>
                </div>
                <div className="priceItem" style={{ whiteSpace: "nowrap" }}>
                  <label>优惠</label>
                  <span className="savingTotal">
                    <span>-</span>
                    {checkedCartItems.size > 0
                      ? formatPrice(cartData.savingTotal)
                      : " ¥ 0"}
                  </span>
                  <span
                    style={{
                      color: "#e71316",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      setDiscountedDetailDrawer(true);
                    }}
                  >
                    查看明细<UpOutlined></UpOutlined>
                  </span>
                </div>
              </div>
              <div className="right">
                <label className="sku-count">({getSkuCount(cartData)}件)</label>
                <label>总计</label>
                <div className="priceItem">
                  <span className="finalTotal">
                    {checkedCartItems.size > 0
                      ? formatPrice(cartData.total)
                      : "¥ 0"}
                  </span>
                </div>
              </div>
            </div>
            <div className="btnWrapper">
              <Button
                disabled={getOrderBtnStatus().disabled}
                className="primaryBtn go-to-settlement-btn"
                onClick={gotoOrderConfirm}
              >
                {getOrderBtnStatus().message}
              </Button>
            </div>
          </div>
        }
      </div>

      <AddShippingAddressFormModal
        visible={showAddShipAddressModal}
        onCancel={() => handleModalClose()}
        onSave={handleSave}
        initialValues={formData}
      ></AddShippingAddressFormModal>
      <Drawer
        className="discountedDetailDrawer total-detail-drawer"
        open={discountedDetailDrawer}
        onClose={() => setDiscountedDetailDrawer(false)}
        width={440}
        placement="bottom"
        getContainer={false}
      >
        <div>
          <h3
            style={{
              textAlign: "center",
              margin: 0,
              padding: 0,
              fontSize: "18px",
            }}
          >
            金额明细
          </h3>
          <p
            style={{
              textAlign: "center",
              margin: 0,
              paddingTop: "5px",
              color: "#70707a",
            }}
          >
            实际优惠金额以下单页为准
          </p>
        </div>
        <div className="priceDetailWrapper">
          <div className="line">
            <label className="bold-property">目录价</label>
            <span>
              {" "}
              <label className="bold-property">
                {checkedCartItems.size > 0
                  ? formatPrice(cartData?.savingDetails?.originalTotal)
                  : "¥ 0.00"}{" "}
              </label>
            </span>
          </div>
          {cartData?.savingDetails?.singleSaving &&
            cartData?.savingDetails?.singleSaving !== "0" &&
            cartData?.savingDetails?.singleSaving !== "0.00" && (
              <div className="line">
                <label className="sub-item">单品优惠</label>
                <span
                  style={{
                    color: "#e71316",
                  }}
                >
                  减 {formatPrice(cartData?.savingDetails?.singleSaving)}
                </span>
              </div>
            )}
            {
              originalPromoTotal &&
                originalPromoTotal !== "0" &&
                originalPromoTotal !== "0.00" && (
                  <div className="line">
                    <label className="bold-property">商品总价</label>
                    <span>
                      {" "}
                      {originalPromoTotal ? (
                        <label className="bold-property">
                          {checkedCartItems.size > 0
                            ? formatPrice(originalPromoTotal)
                            : "¥ 0"}{" "}
                        </label>
                      ) : null}
                    </span>
                  </div>
                )
            }
          {cartData?.savingDetails?.combinationSaving &&
            cartData?.savingDetails?.combinationSaving !== "0" &&
            cartData?.savingDetails?.combinationSaving !== "0.00" && (
              <div className="line">
                <label className="sub-item">组合优惠</label>
                <span
                  style={{
                    color: "#e71316",
                  }}
                >
                  <span style={{ paddingRight: "4px" }}>
                    {cartData?.savingDetails?.singleSaving &&
                      cartData?.savingDetails?.singleSaving !== "0" &&
                      cartData?.savingDetails?.singleSaving !== "0.00"
                      ? "再减"
                      : "减"}
                  </span>
                  <span>
                    {formatPrice(cartData?.savingDetails?.combinationSaving)}
                  </span>
                </span>
              </div>
            )}
          <hr className="hr-wrapper"/>
          <div className="total-wrapper">
            {
                cartData?.savingTotal &&
                cartData?.savingTotal !== "0" &&
                cartData?.savingTotal !== "0.00" ? (
                  <div
                    className="line total-saving"
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    <label className="bold-property flag-label">共减</label>
                    <span
                      style={{
                        color: "#e71316",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {formatPrice(cartData?.savingTotal)}
                    </span>
                  </div>
                ) : 
                  <div
                    className="line total-saving"
                    style={{
                      fontSize: "16px",
                    }}
                  >
                  </div>
            }
            <div
              className="line"
              style={{ lineHeight: "42px", fontSize: "16px", fontWeight: "bold" }}
            >
              <label>合计</label>
              <span>{formatPrice(cartData?.savingDetails?.total)}</span>
            </div>
          </div>  
        </div>
      </Drawer>
      <Drawer
        className="discountedDetailDrawer"
        getContainer={false}
        onClose={() => setRulesDrawerVisible(false)}
        open={rulesDrawerVisible}
        width={440}
        height={"68vh"}
        placement="bottom"
      >
        <PromotionRules
          activityId={activityId}
          tieredRule={tieredRule}
          currentTieredRule={cartData?.currentTieredRule}
          matchStatus={cartData?.matchStatus}
          allowLinearTier={cartData?.allowLinearTier}
          activityDetail={activityDetail}
        />
      </Drawer>
    </div>
  );
};
export default MyCartDrawer;
